import axios from "axios";

import { getConfig } from "~/config";
import { AuthApiError } from "./errors";

export type IdentityProvider = "google" | "microsoft";

export interface CreateSessionRequest {
  provider: IdentityProvider;
  idToken: string;
}

export type SessionSummary = {
  id: string;
  identityId: string;
  clientType: "backoffice" | "mobile" | "web";
  createdAt: number;
};

export type CreateSessionResponse = {
  accessToken: string;
  accessTokenExpiresAt: number;
  refreshToken: string;
  refreshTokenExpiresAt: number;
  session: SessionSummary;
};

const endpointUrl = (): string =>
  new URL(
    "api/kontax/accounts/api/sessions",
    getConfig("VITE_APP_API_URL")
  ).toString();

export const createSession = async (
  request: CreateSessionRequest
): Promise<CreateSessionResponse> => {
  try {
    const response = await axios.post<CreateSessionResponse>(
      endpointUrl(),
      {
        provider: request.provider,
        idToken: request.idToken,
        clientType: "backoffice",
      },
      {
        headers: { "Content-Type": "application/json" },
        validateStatus: (status) => status === 201,
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status ?? null;
      const upstreamMessage = error.response?.data?.message;
      throw new AuthApiError(
        `Failed to create session${
          upstreamMessage ? `: ${upstreamMessage}` : ""
        }`,
        { status, upstreamMessage }
      );
    }
    throw error;
  }
};
